<template>
    <el-dialog append-to-body v-mobile-dialog
               title="云视频通知"
               :visible.sync="visible"
               width="75%"
               :before-close="closeDisclaimer">
        <h4>云视频平台通知</h4>
        <p></p>
        <p>尊敬的用户：</p>
        <p>您好！</p>
        <p>感谢您在复旦云视频会议平台试运行期的理解与支持。为进一步方便用户在网上办事大厅申请、并提升会议服务资源的统筹使用效率，新的申请入口设置在
            eHall（<a href="http://ehall.fudan.edu.cn/new/index.html">http://ehall.fudan.edu.cn/new/index.html</a>），
            您也可以通过微信公众号“复旦信息办”登录“复旦eHall”小程序，搜索“ZOOM使用申请”应用，填写“ZOOM使用申请”表单。
            会议申请经主管部门审批通过后，将由系统完成预约操作，并即时将会议链接发送至您设定的联系邮箱。
        </p>
        <p>
            在使用中遇到任何问题，请发送邮件至<a href="mailto://urp@fudan.edu.cn"> urp@fudan.edu.cn </a>或于服务时间电话联系65643247、65643207咨询。
        </p>

        <span slot="footer" class="dialog-footer">
            <el-checkbox v-model="ivread" class="pull-left" style="font-size: 24px;">我已阅读</el-checkbox>
    <el-button type="primary" @click="closeDisclaimer">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>

    import VueCookie from "vuecookie";

    export default {
        name: "modal-notice",
        data() {
            return {
                visible: false,
                ivread: false
            }
        },
        methods: {
            closeDisclaimer() {
                this.visible = false;
                if (this.ivread) {
                    VueCookie.set('modal_notice', 1, {expires: '10Y'});
                }
            },
        },
        created() {
            if (this.$organization.modal_notice) {
                if (!VueCookie.get('modal_notice')) {
                    this.visible = true;
                }
            }
        }
    }
</script>

<style scoped>

</style>
